<template>
	<div class="menu">
      <div class="wrapper">
		<div class="container">
			<ul class="nav">
				<li class="nav__item">
					<div class="title small faq-link" @click="goToPage('faq')">
					{{ $t('FAQ') }}
					</div>
				</li>
				<!-- <li class="nav__item">
					<div class="title small" @click="scrollToSection('#footer')">
					{{ $t('SOCIAL NETWORK') }}
					</div>
				</li> -->
				<li class="nav__item">
					<router-link to="/products" class="title small">
					{{ $t('SHOP') }}
					</router-link>
				</li>
				<li class="nav__item">	
					<router-link to="/cart" class="title small">
					{{ $t('CART') }}
					</router-link>
				</li>
			</ul>
			<!-- <div class="balance" v-if="$parent.isAuth">
				<button class="button profile-button dark">
					<div class="balance-text">
						<span class="title small gray">{{ $t('Balance:') }}</span>
						<span class="title small amount">{{Math.floor($parent.profileData.balance * 100) / 100}} {{$parent.currency}}</span>
					</div>
					<div class="button plus" @click="$parent.openTopUpModal">
						<img src="../images/plus.svg" class="img"/>
					</div>
				</button>
			</div> -->
			<router-link to="/profile" class="button black" v-if="$parent.isAuth">
				{{ $t('My profile') }}
			</router-link>
			<div class="button steam-login" v-if="!$parent.isAuth" @click="$parent.openSignInModal" @mouseenter="changeToWhiteIcon" @mouseleave="changeToRedIcon">
				<span>{{ $t('LOGIN VIA STEAM') }}</span>
				<img ref="steamIcon" src="../assets/steamred.svg" class="steam-icon"/>
			</div>
			<div class="select-container" v-if="curr && ($parent.currencyOptions.length > 1)">
				<select class="select currency-select" v-model="curr"
					@change="selectCurr()"
				>
					<option :value="item" v-for="item in currOptions" :key="item">{{ item }}</option>
				</select>
			</div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
	name: 'Menu',
	props: ['currency', 'currencyCode', 'currencyValue'],
	data: function() {
		return {
			topUpIsVisible: false,
			amount: 5,
			curr: ''
		}
	},
	computed: {
		currOptions() {
			return this.$parent.currencyOptions.map(({code}) => code);
		}
	},
	watch: {
		currencyCode: function (newValue) {
			this.curr = newValue;
		}
	},
	mounted() {
		this.curr = this.currencyCode;
	},
	methods: {
		selectCurr() {
			localStorage.setItem("currency", this.curr);
			this.changeCurrency(this.curr);
		},
		changeCurrency(item) {
			this.$emit('changeCurrency', item)
		},
		scrollToSection(section) {
			this.$parent.closeMenu();
			this.$emit('scrollToSection', section);
		},
		goToPage(page) {
			this.$parent.closeMenu();
			this.$emit('goToPage', page);
		},
		changeToWhiteIcon() {
			if (this.$refs.steamIcon) {
				this.$refs.steamIcon.src = require('../assets/steamwhite.svg');
			}
		},
		changeToRedIcon() {
			if (this.$refs.steamIcon) {
				this.$refs.steamIcon.src = require('../assets/steamred.svg');
			}
		},
		decrease() { 
			if (this.amount > 0) {
				this.amount = this.amount - 1
			} else {
				this.amount = 0
			}
		},
		increase() {
			this.amount = this.amount + 1
		},
		toCheckout() {
			if (this.amount > 0) {
				this.topUpIsVisible = false;
				this.$emit('setAmount', this.amount);
				this.$router.push({ path: '/topup', query: { amount: this.amount }})
			}
		}
	},
}
</script>
